import React from 'react';
import type { DebugLogEntry } from '../../lib/debugLog';

const levelStyles: Record<string, { bg: string; text: string; label: string }> = {
  info: { bg: 'bg-blue-500/20', text: 'text-blue-400', label: 'INFO' },
  warn: { bg: 'bg-amber-500/20', text: 'text-amber-400', label: 'WARN' },
  error: { bg: 'bg-red-500/20', text: 'text-red-400', label: 'ERR' },
  success: { bg: 'bg-green-500/20', text: 'text-green-400', label: 'OK' },
};

interface Props {
  entry: DebugLogEntry;
}

export const DebugLogEntryRow: React.FC<Props> = ({ entry }) => {
  const style = levelStyles[entry.level] || levelStyles.info;
  const time = entry.timestamp.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
  });

  return (
    <div className="flex items-start gap-2 px-3 py-1.5 text-xs font-mono hover:bg-neutral-800/30">
      <span className="text-neutral-600 shrink-0 w-20">{time}</span>
      <span
        className={`px-1.5 py-0.5 rounded text-[10px] font-semibold shrink-0 ${style.bg} ${style.text}`}
      >
        {style.label}
      </span>
      <span className="text-neutral-500 shrink-0">[{entry.category}]</span>
      <span className="text-neutral-300 break-all">{entry.message}</span>
      {entry.data !== undefined && (
        <span className="text-neutral-600 break-all ml-auto max-w-[200px] truncate">
          {typeof entry.data === 'string' ? entry.data : JSON.stringify(entry.data)}
        </span>
      )}
    </div>
  );
};
